import { render, staticRenderFns } from "./CorporateAnnouncementIpoDetails.vue?vue&type=template&id=78a17cc4&scoped=true"
import script from "./CorporateAnnouncementIpoDetails.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementIpoDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementIpoDetails.vue?vue&type=style&index=0&id=78a17cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a17cc4",
  null
  
)

export default component.exports